import { z } from 'src/lib'
import { InstrumentoPutFields } from './instrumento-fields'
import { getEndpoint } from './httpWRM'
import { BaseResponse } from 'src/types'
import { HttpAxiosRequest } from 'src/http/httpAxiosBase'

const schema = z.object({
    [InstrumentoPutFields.CodOperacionLimiteTipo]: z.number(),
    [InstrumentoPutFields.Excepcion]: z.string(),
    [InstrumentoPutFields.ValorNominal]: z.number(),
    [InstrumentoPutFields.CashValueUSD]: z.number(),
    [InstrumentoPutFields.Instrumento]: z.string()
})

export type OperacionWRMInstrumentoUpdateDTO = z.infer<typeof schema>

export const postInstrumento = (
    idOperacion: number,
    detalleUpdate: OperacionWRMInstrumentoUpdateDTO
): Promise<BaseResponse> => {
    const endpoint = getEndpoint(`${idOperacion}/limites`)

    const parsed = schema.safeParse(detalleUpdate)

    if (!parsed.success) {
        console.error('Error de validación:', parsed.error.issues)

        return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(endpoint, parsed.data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(error => {
            console.error('Error de red:', error)

            return Promise.reject('Error de red.')
        })
}
